import {useContext, useEffect, useLayoutEffect, useState} from 'react';
import useLibrarySeeAll from '../../../hooks/useLibrarySeeAll';
import {searchedItems} from '../../../lib/utils';
import withAlmToken from '../../common/withAlmToken';
import LibrarySubSectionsContainer from './LibrarySubSectionsContainer';
import { AppContext } from '../../../context/AppProvider';
import PageLoader from '../../common/loader/PageLoader';

const LibrarySections = () => {
  const [librarySectionsIds, setLibrarySectionsIds] = useState<any>({});
  const {bookMarkresponse, deleteBookMark, addBookMark} = useLibrarySeeAll();
  const {state } = useContext(AppContext);
  const [loading, setLoading] = useState(true);

  const catalogIds = async () => {
    try {
      const obj: any = {};
      state.catlogList?.forEach((res: any) => {
        if (searchedItems?.includes(res?.attributes?.name.trim())) {
          obj[res?.attributes?.name.trim()] = res;
        }
      });
      setLibrarySectionsIds(obj);
    } catch (error) {
            console.log('error', error);
    } finally {
      setLoading(false); 
    }
  };

  useEffect(() => {
    catalogIds();
  }, [bookMarkresponse, state?.catlogList]);
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    if (history.scrollRestoration) {
      history.scrollRestoration = "manual";
    }
  }, []);

  return (
    <>
      {loading ? (
        <PageLoader />
      ) : (
        <LibrarySubSectionsContainer
          librarySectionsIds={librarySectionsIds}
          addBookMark={addBookMark}
          deleteBookMark={deleteBookMark}
          bookMarkresponse={bookMarkresponse}
        />
      )}
    </>
  );
};

export default withAlmToken(LibrarySections);
